import React, { CSSProperties } from 'react';
import { EdgeProps, getSmoothStepPath } from 'react-flow-renderer';
import { HORIZONTAL_SPACING } from '../../../../../utils/dimensions';
import { getSmoothStepLoopPath } from './utils';

export const Edge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}: EdgeProps) => {
  const RADIUS = 24;
  const SOURCE_OFFSET = 16;
  const TARGET_OFFSET = 16;
  const HANDLE_OFFSET = 5;
  const centerX = (sourceX + targetX) / 2;
  const centerY = targetY + HANDLE_OFFSET - HORIZONTAL_SPACING / 2;

  let style: CSSProperties = {
    stroke: `${data.highlights ? '#C0C0C0' : '#979797'}`,
    strokeWidth: 2,
  };

  if (data.highlighted) {
    style = { ...style, stroke: '#3576ba' };
    if (data.outgoingEdge) {
      style['strokeDasharray'] = '12 4';
    }
  }

  if (data.animated) {
    style['strokeDasharray'] = '12 4';
    style['animation'] = `animate16pxDashes 0.75s linear infinite`;
  }

  let path = '';
  if (targetY < sourceY) {
    path = getSmoothStepLoopPath({
      sourceX,
      sourceY: sourceY - HANDLE_OFFSET,
      targetX,
      targetY: targetY + HANDLE_OFFSET,
      radius: RADIUS,
      sourceOffset: SOURCE_OFFSET,
      targetOffset: TARGET_OFFSET,
    });
  } else {
    path = getSmoothStepPath({
      sourceX,
      sourceY: sourceY - HANDLE_OFFSET,
      sourcePosition,
      targetX,
      targetY: targetY + HANDLE_OFFSET,
      targetPosition,
      borderRadius: RADIUS,
      centerX,
      centerY,
    });
  }

  return (
    <React.Fragment>
      <path
        id={id}
        style={{ ...style }}
        className="react-flow__edge-path"
        d={path}
      />
    </React.Fragment>
  );
};
